import { dateToISOString } from '@orion/fe-utils';

import { graphql } from '__generated__';

import type { AuthUser } from 'common/auth/types';
import gqlClient from 'common/graphql/client';

export async function writeRespondentActivationDate(respondent: AuthUser, isCaregiver: boolean): Promise<void> {
    const input = {
        pk: respondent.pk,
        sk: respondent.sk,
        isDeleted: respondent.isDeleted,
        expectedVersion: respondent.version,
        activationDate: dateToISOString(new Date(), true),
    };

    if (isCaregiver) {
        await gqlClient.mutate({ mutation: UPDATE_CAREGIVER_ACTIVATION_DATE, variables: { input } });
    } else {
        await gqlClient.mutate({ mutation: UPDATE_PATIENT_ACTIVATION_DATE, variables: { input } });
    }
}

const UPDATE_PATIENT_ACTIVATION_DATE = graphql(`
    mutation UpdatePatientActivationDate($input: InputUpdatePatient!) {
        updatePatient(input: $input) {
            pk
            activationDate
            preferredLanguage
        }
    }
`);

const UPDATE_CAREGIVER_ACTIVATION_DATE = graphql(`
    mutation UpdateCaregiverActivationDate($input: InputUpdateCaregiver!) {
        updateCaregiver(input: $input) {
            pk
            activationDate
            preferredLanguage
        }
    }
`);
